module.exports = __webpack_public_path__ + "img/13.042cff8a.png";